<template lang="pug">
  #signUpSuccess.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.text-center.w-100(
      style="flex: 1 1 0;"
    )
      .pt-5
        img.pt-5.pb-3(
          :src='okImg',
          alt='success_ok_img',
          width="74"
        )
        p.font-weight-bold.mb-0(v-if="singUpAndBindSa") 綁定成功
        p.font-weight-bold.mb-0(v-else-if="ecmFastBinding") 綁定成功
        p.font-weight-bold.mb-0(v-else) 資料認證
        hr.border-primary.w-100
        p(v-if="singUpAndBindSa")
          small.d-block.mb-0.px-4 恭喜您成為 TIFFANY & CO. 摯友，
          small.d-block.mb-0.px-4 享有個人化專屬服務以及最新品牌資訊。
          small.d-block.mb-0.px-4 您已完成專屬CA綁定，
          small.d-block.mb-0.px-4 隨時與您的專屬CA進行線上一對一諮詢。
        p(v-else-if="ecmFastBinding")
          small.d-block.mb-0.px-4 恭喜您已完成專屬CA綁定，
          small.d-block.mb-0.px-4 隨時與您的專屬CA進行線上一對一諮詢。
        small.d-block.mb-0.px-4(v-else) 恭喜您成為Tiffany摯友，您即享有完善的個人化功能以及最新品牌資訊。
    button.btn.btn-block.btn-primary(
      type="button",
      @click="goToDownloadWallpaper()"
    ) 前往下載桌布

    button.btn.btn-block.btn-primary(
      type="button",
      @click="backToLINEHandler()"
    ) 返回官方帳號

    .redirectDialog(v-if="redirectPage === 'sticker'") 即將為您轉導至貼圖下載頁面，請勿關閉頁面。

</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';
import { M_MAKE_PICTURE_INDEX } from '@/router/member/make-picture';
import { M_DOWNLOAD_WALLPAPER_INDEX } from '@/router/member/download-wallpaper';
import { mapState } from 'vuex';

export default {
  name: 'memberSuccess',
   props: {
    // 是否綁定成功且順便綁定CA了
    singUpAndBindSa: {
      type: Boolean,
      required: false
    },
    // 透過ecm id 快速綁定
     ecmFastBinding: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      okImg: okImgUrl,
      redirectPage: '',
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.redirectPage = window.sessionStorage.getItem('directBy');
    if (vm.redirectPage === 'sticker') {
      let data = {
        line_uuid: window.sessionStorage.getItem('line_uuid'),
        msg_channel_id: process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID
      }

      vm.$store.dispatch('member_sign_up/getMissionStickerHandler', data)
        .then(() => {
          window.location.href = process.env.VUE_APP_LINE_STICKER_URL;
        })
    }
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
    goToMakePicture() {
      const vm = this;
      vm.$router.push({
        name: M_MAKE_PICTURE_INDEX
      });
    },
    goToDownloadWallpaper() {
      const vm = this;
      vm.$router.push({
        name: M_DOWNLOAD_WALLPAPER_INDEX
      });
    }
  },
  computed: {
  }
};
</script>

<style lang="scss" scoped>
.redirectDialog {
  width: 70%;
  max-width: 240px;
  border: solid 3px;
  background: #fff;
  padding: 45px 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
